// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"2952ce56","832":"64565f4a"}[chunkId] + ".chunk.js";
};